import React, {useEffect, useState} from 'react'
import {KTCard, KTCardBody, KTIcon} from '../../../_websoft/helpers'
import TablePagination from '../../components/TablePagination/TablePagination'
import {
    SortingState,
    flexRender,
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table'
import notifyToast from '../../components/Toast/Toast'
import {TableActionButton} from '../../components/TableActionBtn/TableActionButton'
import {ToastContainer} from 'react-toastify'
import TableSearch from '../../components/TableSearch/TableSearch'
import ExportButton from '../../components/TableExportToExcel/ExportButton'
import {Link, useNavigate} from 'react-router-dom'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'
import {PaginationModel} from '../../models/PaginationModel'
import {ArtikliOperacijeModel, ParamsModelArtikliOperacije} from "../../models/ArtikliOperacije";
import {deleteArtikliOperacije, getArtikliOperacije} from "../../api/artikliOperacije";
import ArtikliGalanterija from "../../components/ArtikliGalanterija/ArtikliGalanterija";
import {useAuth} from "../../modules/auth";

const ArtikliOperacijeLista: React.FC = () => {
    const [data, setData] = useState<ArtikliOperacijeModel[]>([])
    const [loading, setLoading] = useState(true)
    const [pagination, setpagination] = useState<PaginationModel>({
        curPage: 1,
        totalPage: 1,
        perPage: 10,
    })
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [params, setparams] = useState<ParamsModelArtikliOperacije>({per_page: 10, page: 1})

    const [sorting, setSorting] = useState<SortingState>([])
    const [globalFilter, setGlobalFilter] = React.useState('')
    const {currentUser} = useAuth()
    const uposlenikId = currentUser?.UposlenikId

    const updatePage = () => {
        setLoading(true)
        getArtikliOperacije(params)
            .then((response) => {
                const data = response.data['data']
                setData(data)
                const totalPage = Math.floor(response.data['total'] / response.data['per_page'] + 1)
                setpagination({
                    curPage: response.data['current_page'],
                    totalPage: totalPage,
                    perPage: params.per_page,
                })
            })
            .catch((error) => {
                console.error('Error: ', error)
                notifyToast(false, error)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        updatePage()
    }, [params])

    useEffect(() => {
        const {id} = sorting[0] ?? ''
        data.sort((a, b) => a[id] - b[id])
    }, [sorting])

    const columns = [
        {
            id: 'Id',
            header: 'Id',
            accessorKey: 'id',
        },
        {
            id: 'Operacija',
            header: 'Operacija',
            accessorKey: 'naziv',
        },
        {
            id: 'broj Operacija',
            header: 'Broj operacija',
            accessorKey: 'brojOperacija',
        },
        {
            id: 'Šifra artikla',
            header: 'Šifra artikla',
            accessorKey: 'artikal.ArtSifra',
        },
        {
            id: 'Artikal',
            header: 'Artikal',
            accessorKey: 'artikal.ArtNaziv',
        },
        {
            id: 'Norma',
            header: 'Norma',
            accessorKey: 'norma',
        },
        {
            id: 'Norma min.',
            header: 'Norma min.',
            accessorKey: 'normaMinuta',
        },
        {
            id: 'Status',
            header: 'Status',
            accessorKey: 'status',
            cell: ({row}) => (
                row.original.status === 1 ? (
                    <i className='bi bi-check-lg text-success fs-2' title='Aktivan'></i>
                ) : (
                    <i className='bi bi-x-lg text-danger fs-2' title='Neaktivan'></i>
                )
            ),
        },

        {
            id: 'Kreirao',
            header: 'Kreirao',
            accessorKey: 'uposlenik.UposlenikImePrezime',
        },
        {
            header: 'Akcija',
            accessorKey: 'Akcija',
            cell: ({row}) => (
                <TableActionButton
                    onDelete={() => onDelete(row.original.id)}
                    onEdit={() => {
                        onEdit(row.original.id)
                    }}
                />
            ),
        },
    ]
    const table = useReactTable({
        data: data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        state: {
            sorting: sorting,
            globalFilter: globalFilter,
        },
        onGlobalFilterChange: setGlobalFilter,
        getFilteredRowModel: getFilteredRowModel(),
        onSortingChange: setSorting,
    })
    const onDelete = (id) => {
        deleteArtikliOperacije(id)
            .then((response) => {
                notifyToast(true, response)
                setparams({per_page: pagination.perPage, page: pagination.curPage})
            })
            .catch((error) => {
                notifyToast(false, error.data['message'])
            })
    }
    const navigate = useNavigate()

    const onEdit = (rowData) => {
        navigate(`/galanterija/artikli-operacije/izmjena/${rowData}`)
    }

    if (![7, 57, 272].includes(uposlenikId ?? -1)) {
        return (
            <KTCard>
                <KTCardBody className="py-4 text-center text-muted">
                    <h2>Nemate pravo pristupa ovom sadržaju.</h2>
                </KTCardBody>
            </KTCard>
        )
    }

    return (
        <KTCard>
            <ToastContainer/>
            <KTCardBody className='py-4'>
                <div className='col-3 mb-6'>
                    <ArtikliGalanterija onChange={(name, value) => setparams({...params, artikal: value})}/>
                </div>
                <div className='d-flex justify-content-between'>
                    <div data-kt-user-table-toolbar='base'>
                        <TableSearch onSearch={(text) => setGlobalFilter(text)}/>
                    </div>
                    <div data-kt-user-table-toolbar='base'>
                        <ExportButton table={table} filename={'palete-ulazi'}/>
                        <Link to='/galanterija/artikli-operacije/dodaj'>
                            <button type='button' className='btn btn-primary'>
                                <KTIcon iconName='plus' className='fs-2'/>
                                Dodaj
                            </button>
                        </Link>
                    </div>
                </div>
                {loading ? (
                    <LoadingComponent/>
                ) : (
                    <div className='table-responsive mt-3 '>
                        <table className='table align-middle table-bordered gy-5 no-footer'>
                            <thead>
                            {table.getHeaderGroups().map((headerGroup) => (
                                <tr
                                    key={headerGroup.id}
                                    className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-dark p-2'
                                >
                                    {headerGroup.headers.map((header) => (
                                        <th
                                            className='text-white'
                                            key={header.id}
                                            onClick={header.column.getToggleSortingHandler()}
                                        >
                                            {flexRender(header.column.columnDef.header, header.getContext())}
                                            {/* @ts-ignore */}
                                            {{asc: '🔼', desc: '🔽'}[header.column.getIsSorted() ?? null]}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                            </thead>
                            <tbody className='text-gray-600'>
                            {table.getRowModel().rows && table.getRowModel().rows.length > 0 ? (
                                table.getRowModel().rows.map((row) => (
                                    <tr key={row.id}>
                                        {row.getVisibleCells().map((cell) => (
                                            <td key={cell.id}>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={7}>
                                        <div
                                            className='d-flex text-center w-100 align-content-center justify-content-center'>
                                            No matching records found
                                        </div>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                )}
                <TablePagination
                    updatePage={(page, per_page) => setparams({...params, page: page, per_page: per_page})}
                    pagination={pagination}
                />
            </KTCardBody>
        </KTCard>
    )

}
export default ArtikliOperacijeLista;
